export default {"src":"/_next/static/media/404.d777953c.gif","height":1000,"width":1200,"blurWidth":0,"blurHeight":0};